import { useState } from 'react';
import { Box, Button } from '@mui/material';

import { Features } from './Features';
import { useSelectedQuoteStore } from '@store/QuoteStore';
import { useClamp } from '@utils/useClamp';

export const FeacturesList = () => {
  const { selectedQuote } = useSelectedQuoteStore();
  const { clamp } = useClamp();
  const [select, setSelect] = useState('');


  return (
    <Box
      style={{
        marginTop: '5px',
        padding: clamp('16px 10px 16px 150px', '24px 40px', '24px 8px'),
        backgroundColor: 'white',
      }}
      flexDirection={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          height: '48px',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Button
          sx={{
            width: '45%',
            textAlign: 'center',
            fontSize: '16px',
            fontWeight: 700,
            color: select === 'Cobertura' ? '#039ecc' : '#212121',
            textTransform: 'none',
            borderBottom:
              select === 'Cobertura' ? '3px solid #039ecc' : 'unset',
          }}
          onClick={() => {
            setSelect('Cobertura');
          }}
        >
          Coberturas
        </Button>
        <Button
          sx={{
            width: '45%',
            textAlign: 'center',
            fontSize: '16px',
            fontWeight: 700,
            color: select === 'Assist' ? '#039ecc' : '#212121',
            textTransform: 'none',
            borderBottom: select === 'Assist' ? '3px solid #039ecc' : 'unset',
          }}
          onClick={() => {
            setSelect('Assist');
          }}
        >
          Asistencias
        </Button>
      </Box>
      <Box>
        {selectedQuote?.coverages_array?.map((feature: any, index: any) =>
          feature.sum_assured === '' ? null : (
            <Features
              key={`feature-${index}`}
              logo={feature.logo}
              title={feature.name}
              descripcion={feature.descripcion}
              titleTicket={feature.titleTicket}
              numberTicket={feature.deductive}
              feature={feature}
            />
          )
        )}
      </Box>
    </Box>
  );
};
